const CheckIconSVG = ({ className = "" }) => (
  <svg
    className={className}
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.73047 10.3896L1.19141 5.85059C0.917969 5.57715 0.917969 5.1123 1.19141 4.83887L2.17578 3.85449C2.44922 3.58105 2.88672 3.58105 3.16016 3.85449L6.25 6.91699L12.8125 0.354492C13.0859 0.0810547 13.5234 0.0810547 13.7969 0.354492L14.7812 1.33887C15.0547 1.6123 15.0547 2.07715 14.7812 2.35059L6.74219 10.3896C6.46875 10.6631 6.00391 10.6631 5.73047 10.3896Z"
      fill="#50C878"
    />
  </svg>
);
export default CheckIconSVG;
